import { render, staticRenderFns } from "./VaultList.vue?vue&type=template&id=531358dd&"
import script from "./VaultList.vue?vue&type=script&lang=js&"
export * from "./VaultList.vue?vue&type=script&lang=js&"
import style0 from "./VaultList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports